import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { reactivateUserRequest } from "../../../../../../utils/APICalls";
import Loading from "../../../../../../components/loading/loading";
import { getUserDetailsRequest } from "../../../../../../redux/users/slice";
import { useDispatch } from "react-redux";

const styles = {
  closeBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  layout: {
    width: 500,
    mt: -2,
  },
  message: {
    color: "rgba(0, 0, 0, 0.87)",
    mb: 0.5,
  },
  actionBtn: {
    ml: 2,
    mr: 1,
  },
};

interface ReActivateUserDialogProps {
  showDialog: boolean;
  closeDialog: () => void;
  id: string;
  onSuccess?: () => void;
  onError?: (message: string) => void;
}

export default function ReActivateUserDialog({
  showDialog,
  closeDialog,
  id,
  onSuccess,
  onError,
}: ReActivateUserDialogProps) {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const reactivateUser = async () => {
    setLoading(true);
    try {
      const response = await reactivateUserRequest(id);
      setLoading(false);
      if (response?.status === 204) {
        if (!onSuccess) {
          dispatch(getUserDetailsRequest({ id }));
        }
        closeDialog();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        const errorMessage =
          response?.data?.message ||
          "Failed to activate user. Please try again.";
        if (onError) {
          onError(errorMessage);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error activating user:", error);
      if (onError) {
        onError("Failed to activate user. Please try again.");
      }
    }
  };
  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Activate User?</DialogTitle>
      <IconButton aria-label="close" onClick={closeDialog} sx={styles.closeBtn}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.layout}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={styles.message}>
            Are you sure you want to activate this user? The user will
            immediately be able to sign in using previous credentials.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={closeDialog}>
          Cancel
        </Button>
        <Button sx={styles.actionBtn} onClick={reactivateUser} autoFocus>
          Activate User
        </Button>
      </DialogActions>
      {loading && <Loading />}
    </Dialog>
  );
}
